<template>
  <v-col cols="12">
    <v-row no-gutters>
      <v-col cols="12">
        <span class="label primary--text">{{this.name}} <small class="error--text" v-if="required">(obbligatorio)</small></span>
      </v-col>
      <v-col cols="12">
        <v-row no-gutters class="input pt-0 pb-0" align="center" :class="{'inputWarn': required && list.length <= 0}">
          <v-col cols="6">{{this.name}}</v-col>
          <v-col cols="6" class="text-right">
            <v-btn
                fab
                depressed
                dark
                small
                icon
                :disabled="disabled"
                color="primary"
                @click="dialog = true"
            >
              <v-icon dark>
                mdi-plus
              </v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12">
            <v-dialog v-model="dialog" persistent width="800">
              <v-card>
                <v-card-title class="grey lighten-2 pt-2">
                  <span v-if="id === null">Aggiungi {{this.name}}</span>
                  <span v-else>Modifica {{this.name}}</span>
                </v-card-title>
                <v-card-text>
                  <v-row no-gutters>
                    <v-col cols="12" class="pt-7" :class="{'pb-3': swap !== null}">
                      <v-radio-group
                          :disabled="id !== null"
                          v-model="swap"
                          row
                          class="pb-0 mb-0"
                      >
                        <v-radio
                            label="Persona"
                            value="person"
                            class="ml-auto"
                        ></v-radio>
                        <v-radio
                            label="Società"
                            value="company"
                            class="mr-auto"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>
                    <v-col cols="12" v-if="swap">
                      <v-row no-gutters>
                        <v-col cols="12">
                          <v-row no-gutters v-if="swap === 'person'">
                            <v-col cols="6" class="pa-3">
                              <span class="label primary--text">Nome <small class="error--text">(obbligatorio)</small></span>
                              <input type="text" placeholder="Nome" class="input" v-model="data.firstName" :class="{ inputErr: !data.firstName }">
                            </v-col>
                            <v-col cols="6" class="pa-3">
                              <span class="label primary--text">Cognome <small class="error--text">(obbligatorio)</small></span>
                              <input type="text" placeholder="Cognome" class="input" v-model="data.lastName" :class="{ inputErr: !data.lastName }">
                            </v-col>
                          </v-row>
                          <v-row no-gutters v-else>
                            <v-col cols="6" class="pa-3">
                              <span class="label primary--text">Ragione sociale <small class="error--text">(obbligatorio)</small></span>
                              <input type="text" placeholder="Ragione sociale" class="input" v-model="data.businessName" :class="{ inputErr: !data.businessName }">
                            </v-col>
                            <v-col cols="6" class="pa-3">
                              <span class="label primary--text">Partita IVA <small class="error--text">(obbligatorio)</small></span>
                              <input type="text" placeholder="Partita IVA" class="input" v-model="data.vatCode" :class="{ inputErr: !data.vatCode }">
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="6" class="pa-3 pt-0">
                          <span class="label primary--text">Pec <small class="error--text">(obbligatorio)</small></span>
                          <input type="text" placeholder="Pec" class="input" v-model="data.email" :class="{ inputErr: !data.email }">
                        </v-col>
                        <v-col cols="6" class="pa-3 pt-0">
                          <span class="label primary--text">Codice fiscale <small class="error--text">(obbligatorio)</small></span>
                          <input type="text" placeholder="Codice fiscale" class="input" v-model="data.fiscalCode" :class="{ inputErr: !data.fiscalCode }">
                        </v-col>
                        <v-col cols="8" class="pa-3 pt-0">
                          <span class="label primary--text">Indirizzo <small class="error--text">(obbligatorio)</small></span>
                          <input type="text" placeholder="Indirizzo" class="input" v-model="address.street" :class="{ inputErr: !address.street }">
                        </v-col>
                        <v-col cols="4" class="pa-3 pt-0">
                          <span class="label primary--text">Civico <small class="error--text">(obbligatorio)</small></span>
                          <input type="text" placeholder="Civico" class="input" v-model="address.number" :class="{ inputErr: !address.number }">
                        </v-col>
                        <v-col cols="4" class="pa-3 pt-0">
                          <span class="label primary--text">Città <small class="error--text">(obbligatorio)</small></span>
                          <input type="text" placeholder="Città" class="input" v-model="address.city" :class="{ inputErr: !address.city }">
                        </v-col>
                        <v-col cols="4" class="pa-3 pt-0">
                          <span class="label primary--text">Provincia <small class="error--text">(obbligatorio)</small></span>
                          <input-province :province.sync="address.province" :class="{ inputErr: !address.province }"></input-province>
                        </v-col>
                        <v-col cols="4" class="pa-3 pt-0">
                          <span class="label primary--text">CAP <small class="error--text">(obbligatorio)</small></span>
                          <input type="text" placeholder="CAP" class="input" v-model="address.zip" :class="{ inputErr: !address.zip }">
                        </v-col>
                        <v-col cols="12">
                          <v-row no-gutters v-if="swap == 'person'">
                            <v-col cols="6" class="pa-3 pt-0 pb-0">
                              <span class="label">Documento identità <small v-if="name !== 'Beneficiario'" class="error--text">(obbligatorio)</small></span>
                              <input-file id="docs_id" :files.sync="docs.id" :required="name !== 'Beneficiario'"></input-file>
                            </v-col>
                            <v-col cols="6" class="pa-3 pt-0 pb-0">
                              <span class="label">Dichiarazione dei redditi <small v-if="name !== 'Beneficiario'" class="error--text">(obbligatorio)</small></span>
                              <input-file id="docs_declaration" :files.sync="docs.declaration" :required="name !== 'Beneficiario'"></input-file>
                            </v-col>
                            <v-col cols="6" class="pa-3 pt-0">
                              <span class="label">Visura catastale <small v-if="name !== 'Beneficiario'" class="error--text">(obbligatorio)</small></span>
                              <input-file id="docs_survey" :files.sync="docs.survey" :required="name !== 'Beneficiario'"></input-file>
                            </v-col>
                            <v-col cols="6" class="pa-3 pt-0">
                              <span class="label">Altri documenti</span>
                              <input-file id="docs_other" :files.sync="docs.other"></input-file>
                            </v-col>
                          </v-row>
                          <v-row no-gutters v-else>
                            <v-col cols="12" class="pa-3 pt-0 pb-0">
                              <span class="label">Documento identità legale rappresentante <small v-if="name !== 'Beneficiario'" class="error--text">(obbligatorio)</small></span>
                              <input-file id="docs_id" :files.sync="docs.id" :required="name !== 'Beneficiario'"></input-file>
                            </v-col>
                            <v-col cols="12" class="pa-3 pt-0 pb-0">
                              <span class="label">Bilancio completo ultimo esercizio chiuso <small v-if="name !== 'Beneficiario'" class="error--text">(obbligatorio)</small></span>
                              <input-file id="docs_closed" :files.sync="docs.closed" :required="name !== 'Beneficiario'"></input-file>
                            </v-col>
                            <v-col cols="12" class="pa-3 pt-0 pb-0">
                              <span class="label">Bilancio provvisorio esercizio in corso <small v-if="name !== 'Beneficiario'" class="error--text">(obbligatorio)</small></span>
                              <input-file id="docs_partial" :files.sync="docs.partial" :required="name !== 'Beneficiario'"></input-file>
                            </v-col>
                            <v-col cols="6" class="pa-3 pt-0 pb-0">
                              <span class="label">Visura camerale (max 3 mesi) <small v-if="name !== 'Beneficiario'" class="error--text">(obbligatorio)</small></span>
                              <input-file id="docs_survey" :files.sync="docs.survey" :required="name !== 'Beneficiario'"></input-file>
                            </v-col>
                            <v-col cols="6" class="pa-3 pt-0 pb-0">
                              <span class="label">Altri documenti</span>
                              <input-file id="docs_other" :files.sync="docs.other"></input-file>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn
                      color="error"
                      text
                      @click="close"
                  >
                    Annulla
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                      v-if="swap != null && !loading"
                      color="primary"
                      text
                      @click="add"
                  >
                    Conferma
                  </v-btn>
                  <v-progress-circular
                      v-if="swap != null && loading"
                      indeterminate
                      color="primary"
                      class="mr-2"
                      :width="2"
                  ></v-progress-circular>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" v-if="list.length > 0">
        <v-row no-gutters v-for="(item, index) in list" :key="index" align="center" class="pt-1">
          <v-col cols="9">
            <v-row no-gutters>
              <v-col cols="12">
                {{ item.data.businessName }} {{ item.data.firstName }} {{ item.data.lastName }}
              </v-col>
              <v-col cols="12" class="details" v-if="item.data.email || item.data.code ||item.data.piva">
                {{ item.data.email }} {{ item.data.code }} {{ item.data.vatCode }}
              </v-col>
              <v-col cols="12" class="details" v-if="item.address.street || item.address.number || item.address.city || item.address.province || item.address.zip">
                {{ item.address.street }} {{ item.address.number }},
                {{item.address.city}} {{item.address.province.toUpperCase()}} {{item.address.zip}}
              </v-col>
            </v-row>
          </v-col>
          <v-col class="text-right" cols="3" v-if="!disabled">
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon small class="mr-2 ml-2" :color="item.data.status ? 'primary' : 'error'">
                    mdi-brightness-1
                  </v-icon>
                </v-btn>
              </template>
              <span v-if="item.data.status">Completato</span>
              <span v-else>Incompleto</span>
            </v-tooltip>
            <v-btn
                fab
                depressed
                dark
                small
                icon
                color="primary"
                @click="edit(index)"
            >
              <v-icon dark>
                mdi-file-document
              </v-icon>
            </v-btn>
            <v-btn
                fab
                depressed
                dark
                small
                icon
                color="error"
                @click="remove(item)"
            >
              <v-icon dark>
                mdi-delete
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-col>
</template>

<style lang="scss" scoped>
  .label {
    font-weight: 500;
    font-size: 1rem;
  }
  .mr-auto{
    margin-right: 0;
  }
  .ml-auto{
    margin-left: 0;
  }
  .details{
    line-height: 1rem;
    font-size: 0.8rem;
  }
</style>

<script>
import InputFile from "../components/input/file";
import InputProvince from "../components/input/province";
import {db} from "@/main";
export default {
  name:'subject',
  components: {
    InputFile,
    InputProvince
  },
  props: {
    list: {
      type: Array
    },
    name: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    status: {
      type: Number
    },
  },
  watch: {
    swap() {
      if(!this.id) {
        this.data = {
          firstName: "",
          lastName: "",
          businessName: "",
          vatCode: "",
          email: "",
          fiscalCode: "",
        }
        this.address = {
          street: "",
          number: "",
          city: "",
          province: "",
          zip: "",
        }
        this.docs = {
          id: [],
          declaration: [],
          survey: [],
          other: [],
          closed: [],
          partial: []
        }
      }
    },
  },
  methods: {
    async add() {
      this.loading = true
      this.data.status = this.validate()
      if(this.id) {
        let index = this.list.findIndex(x => x.id === this.id)
        this.list[index] = {
          id: this.id,
          data: this.data,
          address: this.address,
          docs: this.docs,
        }
        this.$emit("update:list", this.list)
      } else {
        let elm = {
          data: this.data,
          address: this.address,
          docs: this.docs,
        }
        this.$emit("update:list", this.list.concat(elm))
      }
      this.close()
    },
    async edit(index) {
      this.id = this.list[index].id
      if(!this.id) {
        this.id = 'temp'
      }
      this.dialog = true
      if(this.list[index].data.businessName) {
        this.swap = 'company'
      } else {
        this.swap = 'person'
      }
      this.data.status = this.validate()
      this.data = this.list[index].data
      this.address = this.list[index].address
      if(this.list[index].docs !== undefined) {
        this.docs.id = this.list[index].docs.id
        this.docs.declaration = this.list[index].docs.declaration
        this.docs.survey = this.list[index].docs.survey
        this.docs.other = this.list[index].docs.other
        this.docs.partial = this.list[index].docs.partial
        this.docs.closed = this.list[index].docs.closed
      }
    },
    validate() {
      if(((this.data.firstName && this.data.lastName && this.docs !== undefined && this.docs.declaration !== undefined && this.docs.declaration.length > 0) ||
          this.data.businessName && this.data.vatCode && this.docs !== undefined && this.docs.closed !== undefined && this.docs.closed.length > 0 && this.docs.partial !== undefined
          && this.docs.partial.length > 0) && this.data.email && this.data.fiscalCode && this.address.street && this.address.number && this.address.city && this.address.province && this.address.zip && this.docs.id !== undefined && this.docs.id.length > 0 && this.docs.survey !== undefined && this.docs.survey.length > 0) {
        return true
      } else if(this.$props.name === 'Beneficiario' && (this.data.firstName && this.data.lastName) || (this.data.businessName && this.data.vatCode) && this.data.email && this.data.fiscalCode && this.address.street && this.address.number && this.address.city && this.address.province && this.address.zip) {
        return true
      }
      return false
    },
    close() {
      this.loading = false
      this.swap = null
      this.data = {
        firstName: null,
        lastName: null,
        businessName: null,
        vatCode: null,
        email: null,
        fiscalCode: null,
        status: false,
      }
      this.address = {
        street: null,
        number: null,
        city: null,
        province: null,
        zip: null,
      }
      this.docs = {
        id: [],
        declaration: [],
        survey: [],
        other: [],
        closed: [],
        partial: []
      }
      this.dialog = false
    },
    remove(item) {
      switch (this.name) {
        case "Contraente":
          db.collection('requests').doc(this.$route.params.id).collection("holders").doc(item.id).delete()
          break
        case "Beneficiario":
          db.collection('requests').doc(this.$route.params.id).collection("beneficiaries").doc(item.id).delete()
          break
        case "Coobbligato":
          db.collection('requests').doc(this.$route.params.id).collection("obliged").doc(item.id).delete()
          break
      }
      this.list.splice(this.list.indexOf(item), 1)
    }
  },
  data() {
    return {
      id: null,
      dialog: false,
      loading: false,
      swap: null,
      data: {
        status: false,
        firstName: null,
        lastName: null,
        businessName: null,
        vatCode: null,
        email: null,
        fiscalCode: null,
      },
      address: {
        street: null,
        number: null,
        city: null,
        province: null,
        zip: null,
      },
      docs: {
        id: [],
        declaration: [],
        survey: [],
        other: [],
        closed: [],
        partial: []
      }
    }
  }
}
</script>


